import { AlertPriority, AlertPriorityOrder } from '@ixicare/resources';
import { t } from '~i18n';
import { SimpleAlert } from '~store/Alert/Alerts.types';

class NotificationService {
  private lastNotification?: Notification;
  private permissionStatus?: PermissionStatus;

  constructor() {
    if (typeof window === 'undefined') return;
    if ('permissions' in navigator) {
      navigator.permissions.query({ name: 'notifications' }).then((permissionStatus) => {
        this.permissionStatus = permissionStatus;
      });
    }
  }

  public get isEnabled() {
    return this.permissionStatus?.state === 'granted';
  }

  handlePermissionsChange() {
    console.log('User decided to change his seettings. New permission: ' + this.permissionStatus?.state);
  }

  onPermissionsChange(callback: () => void) {
    this.permissionStatus?.addEventListener('change', callback);
    return () => this.permissionStatus?.removeEventListener('change', callback);
  }

  enable() {
    Notification.requestPermission();
  }
  disable() {}

  updateAlertCounters(activeAlerts: SimpleAlert[]) {
    if (!this.isEnabled) return;
    this.lastNotification?.close();
    if (activeAlerts.length > 0) {
      let description = t('foregroundNotificaton.state.empty.description');
      description = AlertPriorityOrder.map((prio): [AlertPriority, number] => [
        prio,
        activeAlerts.filter((x) => x.priority === prio).length,
      ])
        .filter(([, count]) => count > 0)
        .map(([priority, count]) => `${count} ${t(`alert.priority.${priority.toLowerCase()}`)}`)
        .join(', ');
      const title = t(
        activeAlerts.length ? 'foregroundNotificaton.state.active.title' : 'foregroundNotificaton.state.empty.title',
        { count: activeAlerts.length }
      );
      this.lastNotification = new Notification(title, { body: description });
    }
  }

  disconnected() {
    if (!this.isEnabled) return;
    this.lastNotification?.close();
    this.lastNotification = new Notification(t('foregroundNotificaton.state.disconnected.title'), {
      body: t('foregroundNotificaton.state.disconnected.description'),
    });
  }
}

export default new NotificationService();
